export default __webpack_public_path__ + "static/media/loading.89cf4d38.png";